import React, { useEffect, useState } from "react";
import { InputAuto } from "../../../../../controls";
import { action, API, controller } from "../../../../../api/api";
import { Dialog } from "../../../../../layout";
import AddEditCstmr from "../../../../Customer/CustomerForm/AddEditCstmr";

const SelectCustomer = ({ values, setValues }) => {
  const [cstmrs, setCstmrs] = useState([]);
  const [newAddingValue, setNewAddingValue] = useState("");
  const [showCstmrForm, setShowCstmrForm] = useState(false);

  useEffect(() => {
    API(controller.Customer + action.GetAllByOrg).get((res) => {
      res &&
        res.status === 200 &&
        setCstmrs([
          ...res.result.map((j) => ({
            ...j,
            label: `${j.firstName + " " + j.lastName} ${
              j.CstmrGroup ? " | " + j.CstmrGroup.name : ""
            }`,
            subtitle: `${j.cstmrCode} ${j.phone && " | " + j.phone}`,
          })),
        ]);
    });

    return () => {};
  }, []);

  const handleCustomer = (e) => {
    setValues((j) => ({ ...j, customerId: e.target.value }));
  };

  const handleAddNewCstmr = (val) => {
    setNewAddingValue(val);
    setShowCstmrForm(!showCstmrForm);
  };

  const handleNewCstmr = (val) => {
    if (val) {
      setCstmrs([
        {
          ...val,
          label: `${val.firstName + " " + val.lastName} ${
            val.CstmrGroup ? " | " + val.CstmrGroup.name : ""
          }`,
          subtitle: `${val.cstmrCode} ${val.phone && +" | " + val.phone}`,
        },
        ...cstmrs,
      ]);
      setValues((j) => ({ ...j, customerId: val.id }));
      setNewAddingValue("");
    }
  };

  return (
    <>
      <InputAuto
        placeholder="Select Customer"
        value={values.customerId}
        onChange={handleCustomer}
        options={cstmrs}
        fullWidth
        enableAddBtn={true}
        handleAdd={handleAddNewCstmr}
      />

      {/* Add new customer */}
      {showCstmrForm && (
        <Dialog show={showCstmrForm} onClose={false} maxWidth="md">
          <AddEditCstmr
            {...{
              setShowForm: setShowCstmrForm,
              openFromOtherSide: true,
              customerName: newAddingValue,
              handleResult: handleNewCstmr,
            }}
          />
        </Dialog>
      )}
    </>
  );
};

export default SelectCustomer;
